import { render, staticRenderFns } from "./ExpiredOrInvalidCodeView.vue?vue&type=template&id=474800a8&scoped=true&"
import script from "./ExpiredOrInvalidCodeView.vue?vue&type=script&lang=js&"
export * from "./ExpiredOrInvalidCodeView.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredOrInvalidCodeView.vue?vue&type=style&index=0&id=474800a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474800a8",
  null
  
)

export default component.exports